import { render, staticRenderFns } from "./DialogConfirmDelete.vue?vue&type=template&id=650965aa&scoped=true&"
import script from "./DialogConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmDelete.vue?vue&type=style&index=0&id=650965aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650965aa",
  null
  
)

export default component.exports